export interface MembershipPlan {
  id: number;
  name: string;
  durationDays: number;
  validityDays: number;
  price: number;
  /** Yasal KDV oranı (0/1/10/20); null = fiskal cihazın varsayılanı. */
  vatRate?: number | null;
  /**
   * Opsiyonel fiş satır dekompozisyonu (giriş tipleriyle aynı): üçü birlikte
   * dolu ya da boş. Doluysa fiş: ayrılan bileşen + kalan (plan adı, vatRate).
   */
  productPortionLabel?: string | null;
  productPortionAmount?: number | null;
  productPortionVatRate?: number | null;
  status: MembershipPlanStatus;
  createdAt: string;
  updatedAt: string;
  branchId: number;
  branch?: {
    id: number;
    name: string;
    company: {
      id: number;
      name: string;
    };
  };
  _count: {
    memberships: number;
  };
}

export enum MembershipPlanStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE'
}
